// src/locales/en/returnBatch.js
export const returnBatch = {
  // Page Titles
  createReturnBatch: "Process Returns",
  allReturnBatches: "Return Batches",
  returnBatchDetails: "Return Batch Details",
  viewAndManageAllReturnBatches: "View and manage all return batches",
  
  // Main Interface
  scanToReturn: "Scan to Return",
  scanAirwaybillOrOrder: "Scan Airwaybill or Order Number",
  scanPlaceholder: "Scan barcode or enter order/airwaybill number...",
  
  // Courier & Warehouse Selection
  selectCourier: "Select Courier Account",
  selectCourierFirst: "Select a courier account to begin",
  selectWarehouse: "Select Warehouse",
  selectWarehouseFirst: "Select a warehouse to begin",
  courierRequired: "Courier account is required",
  warehouseRequired: "Warehouse is required",
  
  // Batch Management
  activeBatch: "Active Batch",
  noBatchFound: "No active batch found",
  newBatchWillBeCreated: "A new batch will be created on first scan",
  multipleBatchesFound: "Multiple batches found",
  selectBatch: "Select Batch",
  createNewBatch: "Create New Batch",
  batchNumber: "Batch Number",
  switchBatch: "Switch Batch",
  closeBatch: "Close Batch",
  confirmCloseBatch: "Are you sure you want to close batch {batchNumber}? This action cannot be undone.",
  confirmBulkClose: "Are you sure you want to close {count} batch(es)?",
  batchClosedSuccessfully: "Batch closed successfully",
  bulkClosedSuccessfully: "Successfully closed {count} batch(es)",
  failedToCloseBatch: "Failed to close batch",
  failedToCloseSomeBatches: "Failed to close some batches",
  noActiveBatchesSelected: "No active batches selected",
  
  // Current Batch Info
  currentBatch: "Current Batch",
  totalOrders: "Total Orders",
  totalValue: "Total Value",
  createdBy: "Created By",
  createdAt: "Created At",
  
  // Scan Results
  orderReturned: "Order Returned Successfully",
  returnFailed: "Return Failed",
  orderNumber: "Order Number",
  airwaybillNumber: "Airwaybill",
  customerName: "Customer",
  grandTotal: "Total",
  codAmount: "COD Amount",
  paymentType: "Payment Type",
  shop: "Shop",
  newStatus: "New Status",
  
  // Stock Movements
  stockRestored: "Stock Restored",
  stockMovements: "Stock Movements",
  productName: "Product",
  quantityRestored: "Qty Restored",
  viewStockDetails: "View Stock Details",
  
  // Recent Returns
  recentReturns: "Recent Returns",
  noReturnsYet: "No returns in this session yet",
  returnedOrders: "Returned orders will appear here",
  
  // Error Messages
  orderNotFound: "Order not found",
  orderAlreadyReturned: "Order already returned",
  orderNotDispatched: "Order not dispatched",
  orderFromDifferentCourier: "Order from different courier",
  orderFromDifferentWarehouse: "Order from different warehouse",
  orderAlreadyClosed: "Order already closed",
  scanRequired: "Please scan an order",
  failedToReturn: "Failed to return order",
  failedToLoadBatches: "Failed to load return batches",
  failedToLoadReferenceData: "Failed to load reference data",
  failedToCreateBatch: "Failed to create batch",
  failedToLoadBatchDetails: "Failed to load batch details",
  
  // Notes
  addNotes: "Add Notes",
  notesPlaceholder: "Add any notes about this batch...",
  notes: "Notes",
  batchNotes: "Batch Notes",
  returnNotes: "Return Notes",
  notesOptional: "Notes (Optional)",
  
  // Actions
  clear: "Clear",
  viewDetails: "View Details",
  viewAllBatches: "View All Batches",
  processReturns: "Process Returns",
  closeSelected: "Close Selected ({{count}})",
  back: "Back",
  backToBatches: "Back to Batches",
  addMoreOrders: "Add More Orders",
  printReport: "Print Report",
  exportOrders: "Export Orders",
  createBatchNow: "Create Batch Now",
  createBatch: "Create Batch",
  cancel: "Cancel",
  processing: "Processing...",
  closing: "Closing...",
  
  // Statistics
  todayReturns: "Today's Returns",
  sessionReturns: "This Session",
  batchReturns: "Batch Returns",
  batchValue: "Batch Value",
  thisSession: "This Session",
  avgOrderValue: "Avg Order Value",
  codOrders: "COD Orders",
  prepaidOrders: "Prepaid Orders",
  
  // Keyboard Shortcuts
  keyboardShortcuts: "Keyboard Shortcuts",
  focusInput: "Focus input field",
  submitScan: "Submit scan",
  clearForm: "Clear form",
  newBatch: "New batch",
  
  // Empty States
  noActiveBatch: "No Active Batch",
  selectCourierToBegin: "Select a courier account to begin processing returns",
  noReturnBatchesYet: "No return batches yet. Start processing returns to create batches.",
  noBatchesFound: "No batches match your search criteria",
  noOrdersFound: "No orders found",
  noOrdersMatchFilters: "No orders match your current filters",
  
  // Validation
  identifierRequired: "Order identifier is required",
  pleaseScanOrder: "Please scan an order",
  pleaseSelectCourier: "Please select a courier account",
  pleaseSelectWarehouse: "Please select a warehouse",
  
  // Success Messages
  batchCreatedSuccessfully: "Return batch created successfully",
  orderAddedSuccessfully: "Order added to batch successfully",
  batchCreatedAutomatically: "Batch {batchNumber} created automatically",
  orderReturnedSuccessfully: "Order {orderNumber} returned successfully",
  ordersExportedSuccessfully: "Orders exported successfully",
  
  // Filter Labels
  warehouse: "Warehouse",
  courierCompany: "Courier Company",
  courierAccount: "Courier Account",
  account: "Account",
  courier: "Courier",
  orders: "Orders",
  dateRange: "Date Range",
  searchByBatchNumber: "Search by batch number...",
  searchOrders: "Search orders...",
  allWarehouses: "All Warehouses",
  allCourierCompanies: "All Courier Companies",
  allCourierAccounts: "All Courier Accounts",
  allStatuses: "All Statuses",
  allStatus: "All Status",
  
  // Status Labels
  statusActive: "Active",
  statusClosed: "Closed",
  status: "Status",
  success: "Success",
  failed: "Failed",
  pending: "Pending",
  restored: "Restored",
  notRestored: "Not Restored",
  
  // Headers and Sections
  setup: "Setup",
  multipleActiveBatchesFound: "Multiple Active Batches Found",
  orderReturnedSuccessfully: "Order Returned Successfully!",
  scanToRestoreInventory: "Scan returned orders to restore inventory",
  loadingBatchDetails: "Loading batch details...",
  batchNotFound: "Batch not found",
  
  // Details Page
  created: "Created",
  closed: "Closed",
  by: "by",
  unknown: "Unknown",
  copyAirwaybill: "Copy airwaybill",
  
  // Breakdowns
  paymentTypeBreakdown: "Payment Type Breakdown",
  shopBreakdown: "Shop Breakdown",
  activityTimeline: "Activity Timeline",
  ordersInBatch: "Orders in Batch",
  
  // Order Details
  orderDetails: "Order Details",
  deliveryAddress: "Delivery Address",
  contactNumbers: "Contact Numbers",
  orderStatus: "Order Status",
  currentStatus: "Current Status",
  errorMessage: "Error Message",
  primary: "Primary",
  
  // Timeline
  batchCreated: "Batch Created",
  orderAdded: "Order {orderNumber} Added",
  addedBy: "Added by",
  closedBy: "Closed by",
  
  // Table Headers
  airwaybill: "Airwaybill",
  customer: "Customer",
  phone: "Phone",
  city: "City",
  payment: "Payment",
  orderValue: "Order Value",
  stock: "Stock",
  returnedBy: "Returned By",
  returnedAt: "Returned At",
  
  // Misc
  na: "N/A",
  qty: "Qty",

  // Order Items & Product List
  items: "Items",
  orderItems: "Order Items",
  productListTitle: "Product List ({{count}})",
  viewOrdersTab: "Orders",
  viewProductsTab: "Products",
  searchProductsPlaceholder: "Search products...",
  productColumn: "Product",
  skuColumn: "SKU",
  totalQuantityColumn: "Total Quantity",
  orderCountColumn: "Orders",
  loadingProductList: "Loading product list...",
  noProductsFound: "No products found",
  noProductsFoundDescription: "No products match your current filters",
  loadProductListError: "Failed to load product list",
  printProductList: "Print",
  exportExcel: "Excel",
  exportPdf: "PDF"
};